export const badgeColorByStatusId = (statusId?: number) => {
  switch (statusId) {
    case 0:
    case 4:
    case 5:
      return 'badge-light-success'
    case 1:
    case 6:
    case 3:
      return 'badge-light-primary'
    case 2:
    case 7:
      return 'badge-light-warning'
    case 9:
      return 'badge-light-info'
    default:
      return 'badge-light-danger'
  }
}
